import { Typography } from '@mui/joy';

export function Label({ children }) {
  return (
    <Typography level="title-xs" sx={{ 
      backgroundColor: 'var(--joy-palette-primary-100)', 
      color: 'var(--joy-palette-primary-500)', 
      fontSize: '9px',
      padding: '3px 7px', 
      borderRadius: '6px',
      position: 'relative',      
    }}>{children}</Typography>
  );
}